<template>
  <div>
    <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data">
      <i><img :src="$getThemeImagePath('no-data.png')" alt=""></i>
      <p>{{ $t('Bao.no_relevant_data_records') }}</p>
      <span>{{ $t('Bao.search_results_are_empty') }}</span>
    </div>
    <template v-else-if="record.length > 0">
      <div class="history-list-pc">
        <table class="history-table">
          <thead>
            <tr>
              <th scope="col" class="text-center">
                {{ $t("Bao.type") }}
              </th>
              <th scope="col" class="text-center">
                {{ $t("Bao.wallet_type") }}
              </th>
              <th scope="col" class="text-center">
                {{ $t("Bao.amount") }}
              </th>
              <th scope="col" class="text-center">
                {{ $t("Bao.time") }}
              </th>
              <th scope="col" class="text-center">
                {{ $t("Bao.order_number") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in record" :key="key">
              <td class="index text-center">
                {{ item.action_type_label }}
              </td>
              <td class="product text-center">
                {{ getWalletText(item.wallet_type) }}
              </td>
              <td class="ingredient text-center">
                {{ item.amount_in_wallet | numberFormat }} <img class="his-icon" :src="item.image">
              </td>
              <td class="price text-center">
                {{ item.formattedTime }}
              </td>
              <td class="add-btn text-center">
                {{ item.ref_id }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="history-list-mobile">
        <ul class="history-list-container-mobile">
          <li v-for="(item, key) in record" :key="key" class="board board-list">
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.type") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.action_type_label }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.wallet_type") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ getWalletText(item.wallet_type) }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.amount") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.amount_in_wallet | numberFormat }} <img class="his-icon" :src="item.image">
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.time") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.formattedTime }}
              </div>
            </div>
            <div class="con-box">
              <div class="fs-14px">
                {{ $t("Bao.order_number") }}
              </div>
              <div class="con-date fs-14px fw-700">
                {{ item.ref_id }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalHistory',
  props: {
    record: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    firstLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    getWalletText() {
      return (wallet) => {
        switch (wallet) {
          case 'main':
            return this.$t('Bao.other_main')
          case 'bonus':
            return this.$t('Bao.other_bonus')
          case 'commission':
            return this.$t('Bao.other_commission')
          default:
            return wallet
        }
      }
    }
  },
  created() {

  },
  methods: {

  }
}
</script>
